var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-select-button-wrapper",class:[
    {
      'gl-select-button__gray': _vm.grey,
      'gl-select-button__gray--wide': _vm.grey && _vm.grayPadding === 'wide',
      'gl-select-button__underline': _vm.underline,
    },
  ]},[_vm._l((_vm.options),function(item,i){return [(!item.hide)?_c('div',{key:i,staticClass:"gl-select-button__item",class:[
        { 'gl-select-button__item--active': item.value === _vm.value?.value },
        { 'gl-select-button__disabled': _vm.disabled },
        { 'gl-select-button__item--disabled': item.disabled },
      ],on:{"click":function($event){return _vm.itemClick(item)}}},[(item.profit)?_c('div',{staticClass:"gl-select-button__item--profit"},[_vm._v(" "+_vm._s(item.profit)+" ")]):_vm._e(),_vm._t("item-slot",function(){return [_vm._v(" "+_vm._s(item.name)+" ")]},{"item":item})],2):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }